import React, { useState } from 'react'
import CenteredModal from '../../../../../../components/Modal/CenteredModal'
import CustomDropdown from '../../../../../../components/dropdown/CustomDropdown'
import { api } from '../../../../../../api/learningPath'
import { useMutation, useQuery } from 'react-query'
import toast from 'react-hot-toast'

type AssignSurveyModalProps = { 
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  activeActionPlanId: string
}
const AssignSurveyModal: React.FC<AssignSurveyModalProps> = ({open, setOpen, activeActionPlanId}) => {

  const orgId = JSON.parse(sessionStorage.getItem("user")!)?.org?.id;
  const [survey, setSurvey] = useState<string>('')
  const {mutateAsync} = useMutation(api.assignSurvey)

  const {
            data: surveys,
            isLoading,
          } = useQuery(
            ["get survey", orgId],
            () => {
              return api.getOrgSurveys({id: orgId, });
            },
            {
              staleTime: 3000,  
              cacheTime: 3000,  
              select: (data) => data?.data,
            }
          );

  const assignSurvey = async () => {
    try {
         if(!survey) return toast.error('Error! select survey')
          toast.loading('Loading...');
          const response = await mutateAsync({
            org_id: orgId, response_id: survey, actionPlanId: activeActionPlanId
          });
          toast.remove();
          toast.success(response.message);
           setOpen(false)
           setSurvey('')
        } catch (error: any) {
          toast.remove();
          toast.error(error?.response?.data?.message);
        }
  }

  return (
    <>
      {
        //@ts-ignore
        <CenteredModal
          title="Assign Survey To Action Plan"
          withCloseBtn={false}
          open={open}
          setOpen={setOpen}
          width={'w-[400px]'}
      >
        <section style={{ zIndex: 10000000 }} className='relative text-left'>
        <label className='text-sm'>Select Survey</label>
        <select className={'bg-primaryGray mb-3 input-md'} value={survey}
         onChange={(event: React.ChangeEvent<HTMLSelectElement>) => setSurvey(event.target.value)}
        >
           <option value="">Select Survey</option>
           {
           (!surveys?.length || isLoading) ?
             <option value="">Loading..</option>
           :
            surveys?.map( (survey: any) => {
               return (
                 <option 
                 value={survey?.id} key={survey?.id} 
                 >
                  {survey?.name}
              </option>
               )
            } )
           } 
        </select>
        <div className='flex justify-end items-center mt-2'>
            <button onClick={assignSurvey} className='btn bg-primary-blue'>
            Assign Survey
            </button>
        </div>
        </section>
      </CenteredModal>
      }
    </>
  )
}

export default AssignSurveyModal